module.exports = __webpack_public_path__ + "static/media/user-placeholder.5ec6a923.jpg";